export default {
  options: {},
  issues: [],
  summary: {
    sessions: [],
    subjects: [],
    tasks: [],
    modalities: [],
    totalFiles: [],
    size: 0,
  },
}
